/**
 * Upload Fonts modal layout — edit these values to change size and body split.
 */
export const CUSTOM_FONTS_MODAL_LAYOUT = {
  modalWidth: 430,
  modalHeight: "auto",
  modalMinWidth: 430,
  modalMaxWidth: 430,
  modalMinHeight: 333,
  modalMaxHeight: 470,
  dropzoneHeightPercent: 40,
  listMinHeightPercent: 0,
  listMaxHeightPercent: 60,
};

export function resolveCustomFontsModalLayout(overrides = {}) {
  return { ...CUSTOM_FONTS_MODAL_LAYOUT, ...overrides };
}

/** Builds flex layout so dropzone stays on top and the font list fills space below. */
export function buildCustomFontsModalBodyStyle() {
  return {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  };
}
